/* eslint-disable max-lines */
import GridChipFilterContainer from 'components/GridChipFilterContainer/GridChipFilterContainer';
import Text from 'components/base/Text';
import {
  TEAM_TYPES,
  SEARCH_DATE_FORMAT,
  TRACKING,
  YEARS_PARAM
} from 'common/constants/constants';
import { matchContributorMetricsToContributor } from 'common/services/contributors.service';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import {
  convertSearchToRequest,
  trackSearch,
  AUTOCOMPLETE_TYPES
} from 'components/GridChipFilterContainer/helpers';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import _ from 'lodash';
import moment from 'moment';
import QueryString from 'query-string';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getContributorAvatarUrl } from 'common/constants/Avatars';
import {
  isSelectedTeamParentSelector,
  teamsWithExtraSyncedDataSelector
} from 'state/selectors/teams';
import {
  contributorsSelector,
  selectedTeamFlatContributorsSelector
} from 'state/selectors/contributors';
import { getTeams as getTeamsOnRange } from 'common/services/teams.service';
import { CAN_EDIT_ACCOUNT_TYPES, metricNames } from '@linearb/linjs-common';
import {
  convertMetricsNameToV3,
  getMetricsV3WithTotals
} from 'common/services/metrics.service';
import { getTeamInfo, teamsToContributorsResolver } from './teamHistoryUtil';
import { columns, getContributorsTableData } from './individuals.service';
import debounce from 'debounce-promise';
import usePrevious from 'components/hooks/usePrevious';
import { getMinDateForDatePicker } from 'common/utils/utils';
import withPermissions from 'connected-components/HOC/PermissionsHOC';
import { useHistory, useLocation } from 'react-router-dom';
import useTeams from 'views/root/views/home/views/settings/views/ContributorsAndTeams/Teams/useTeams';
import { useAllTeams } from 'components/hooks/useAllTeams';
import { SELECTED_TIME_RANGE_CODE } from 'common/constants/people';
import useBenchmarkOrgSizeConfig from 'views/root/views/home/hooks/useBenchmarkOrgSizeConfig';
import { LBButton } from '@linearb/buzz';

const ALL_METRICS = [
  metricNames.ACTIVE_BRANCHES,
  metricNames.DONE_BRANCHES,
  metricNames.CYCLE_TIME,
  metricNames.REVIEWS,
  metricNames.REVIEW_DEPTH,
  metricNames.ACTIVE_DAYS,
  metricNames.COMMIT_CODE_CHANGES,
  metricNames.NEW_WORK,
  metricNames.REWORK,
  metricNames.REFACTOR,
  metricNames.PR_NEW,
  metricNames.TIME_TO_PR,
  metricNames.TIME_TO_REVIEW,
  metricNames.REVIEW_TIME,
  metricNames.TIME_TO_PROD,
  metricNames.COMMIT_INVOLVED_REPOS_COUNT
];
const initialMetricsState = {
  items: [],
  length: 0
};

const filterChipLabelMap = {
  teams: 'Team',
  contributors: 'Member'
};

const threeYearsAgo = moment()
  .subtract(3, YEARS_PARAM)
  .format(SEARCH_DATE_FORMAT);

// eslint-disable-next-line max-lines-per-function
const Individuals = ({
  currentTeams,
  getContributors,
  iterationsPickerData,
  latestIteration,
  currentIteration,
  isVPMode,
  selectedTeam,
  uiState = {},
  toggleModal,
  toggleSnackBar,
  isTeamLicense,
  gitIntegrations,
  license,
  gitScopeToggle
}) => {
  const { onConfigureTeam, onConfigureGroup } = useTeams();
  const history = useHistory();
  const location = useLocation();
  const { selectedTeamId } = uiState;
  const { benchmarkOrgSize } = useBenchmarkOrgSizeConfig();
  const contributors = useSelector(selectedTeamFlatContributorsSelector) || [];
  const allContributors = useSelector(contributorsSelector);
  const isSelectedTeamParent = useSelector(isSelectedTeamParentSelector);
  const teamsForEditTeamsModal = useSelector(teamsWithExtraSyncedDataSelector);
  const teamsForEditTeamsModalById = _.keyBy(teamsForEditTeamsModal, 'id');
  const selectedTeamForEditTeamsModal =
    teamsForEditTeamsModalById[selectedTeamId] || {};
  const { children = [], isParent, type } = selectedTeamForEditTeamsModal;
  const isGroup = children.length > 0 || isParent || type === TEAM_TYPES.GROUP;
  const showTeams = isVPMode || isSelectedTeamParent;
  const [selectedTimeContributorsMap, setSelectedTimeContributorsMap] =
    useState();
  const [currentContributorsMap, setCurrentContributorsMap] = useState({});
  const [metrics, setMetrics] = useState(
    Object.assign({}, initialMetricsState)
  );
  const [returnNoData, setReturnNoData] = useState(false);
  const search = QueryString.parse(location.search, {
    ignoreQueryPrefix: true
  });

  const { isAllTeams } = useAllTeams();

  const abortConRef = useRef();

  const TABLE_SKELETONS = [
    'avatar-multiline',
    'singleline-random',
    'singleline-random',
    'singleline-random',
    'singleline-random',
    'singleline-random',
    'singleline-random',
    'singleline',
    'singleline-random',
    'singleline-random',
    'singleline-random'
  ];
  const filtersConfig = {
    time: {
      type: 'date',
      reqKey: 'time',
      maxDate: () => moment().format(SEARCH_DATE_FORMAT),
      minDate: () => getMinDateForDatePicker(license)
    },
    contributors: {
      type: 'multi-autocomplete',
      reqKey: 'contributor_ids',
      options: contributors,
      getAvatar: ({ name, extended_data, id }) => ({
        url: getContributorAvatarUrl({ extended_data, id }),
        name
      })
    },
    teams: {
      type: 'multi-tree-dropdown',
      reqKey: 'team_ids',
      options: currentTeams,
      getAvatar: ({ initials: name, color }) => ({
        name,
        color,
        withContent: true
      })
    },
    order_by: {
      type: 'order_by',
      reqKey: 'order_by'
    }
  };

  const previousSearch = usePrevious(search);
  const previousSelectedTeam = usePrevious(selectedTeam);
  const [startDate = null, endDate = null] = _.get(search, 'time', '').split(
    ','
  );

  /*
   * Check the time range—
   * 0 If it doesn't match any iteration
   * 1 If it matches the current iteration
   * 2 If it is a retrospect iteration
   * @Note: this logic already exists as a reselector
   */
  const timeRangeIteration = iterationsPickerData
    .filter(iteration => !iteration.isComputed)
    .reduce((result, iteration) => {
      if (
        startDate === latestIteration.start_date &&
        endDate === latestIteration.end_date
      )
        return SELECTED_TIME_RANGE_CODE.CURRENT_ITERATION;
      if (iteration.start_date === startDate && iteration.end_date === endDate)
        return SELECTED_TIME_RANGE_CODE.RETROSPECT;
      return result;
    }, SELECTED_TIME_RANGE_CODE.CUSTOM);

  const memoizedGetContributors = useCallback(
    debounce(
      async ({
        order_by,
        filter: { time, contributor_ids, team_ids },
        offset,
        limit,
        team_git_scope_disabled
      }) => {
        try {
          if (abortConRef.current) abortConRef.current.abort();
          abortConRef.current = new AbortController();
          const payload = {
            limit,
            offset,
            roll_up: 'custom',
            return_no_data: returnNoData,

            ...(contributor_ids ? { contributor_ids } : {}),
            ...(team_ids ? { team_ids } : {}),
            order_by,
            team_git_scope_disabled
          };

          time = time || {
            before: moment().format(SEARCH_DATE_FORMAT),
            after: moment().subtract(12, 'months').format(SEARCH_DATE_FORMAT)
          };
          const metricsV3Data = await getMetricsV3WithTotals(
            {
              ...payload,
              requested_metrics: convertMetricsNameToV3(ALL_METRICS, 'avg'),
              time_ranges: [time],
              group_by: 'contributor'
            },
            { signal: abortConRef.current.signal }
          );

          const mappedMetrics = metricsV3Data.data.map(
            ({ group, data: groupData }) =>
              groupData.map(teamData => ({
                ...teamData,
                contributor_id: group
              }))
          );

          const metrics = [
            {
              items: mappedMetrics.flat(),
              total: metricsV3Data.total
            }
          ];

          setMetrics({
            ...metrics[0],
            items: matchContributorMetricsToContributor(
              allContributors,
              metrics[0].items
            )
          });
          return metrics;
        } catch (e) {
          if (_.get(e, 'message') === 'canceled') {
            return;
          }
          setMetrics(Object.assign({}, initialMetricsState));
          return Promise.reject(e);
        }
      },
      1000
    ),
    [returnNoData, allContributors, selectedTeam]
  );

  const getReqFilterBody = () => {
    const search = QueryString.parse(location.search, {
      ignoreQueryPrefix: true
    });

    return convertSearchToRequest(search, filtersConfig);
  };
  useEffect(() => {
    setCurrentContributorsMap(
      teamsToContributorsResolver(currentTeams, null, null, true)
    );
  }, [currentTeams]);

  useEffect(() => {
    const search = QueryString.parse(location.search, {
      ignoreQueryPrefix: true
    });
    trackSearch(
      TRACKING.EVENTS.FILTER,
      search,
      [],
      TRACKING.PAGES.PEOPLE,
      TRACKING.PAGE_TABS.INDIVIDUAL
    );

    const fetchTeamsData = async (time = '') => {
      const [startDate, endDate] = time.split(',');
      // Todo: fix double call to teams api
      const teamsOnRange = await getTeamsOnRange({
        from: startDate || threeYearsAgo,
        to: endDate
      }).catch(() => []);
      setSelectedTimeContributorsMap(
        teamsToContributorsResolver(teamsOnRange, startDate, endDate)
      );
    };
    const hasTimeRangeChanged =
      previousSearch && search.time !== previousSearch.time;
    const hasTeamChanged = previousSelectedTeam !== selectedTeam;
    const shouldFetchData =
      hasTimeRangeChanged || hasTeamChanged || !selectedTimeContributorsMap;
    if (shouldFetchData) {
      fetchTeamsData(search.time);
    }
  }, [location.search, selectedTeam]);

  const filtersGroupMap = [
    { type: 'date', names: 'time', defaultIsOpen: true, title: '' },
    {
      type: 'autocomplete',
      items: [{ name: 'contributors', addAvatars: true }],
      title: 'Members',
      defaultIsOpen: true
    },
    showTeams
      ? {
          type: 'autocompleteByType',
          items: [
            {
              type: AUTOCOMPLETE_TYPES.TREE_TEAMS_DROPDOWN,
              name: 'teams',
              defaultIsOpen: true,
              addAvatars: true,
              multiple: false,
              isDisableChildrenOfSelectedParent: false
            }
          ],
          title: 'Teams',
          defaultIsOpen: true
        }
      : null
  ].filter(Boolean);

  let tableColumns = [...columns];

  /**
   * Change columns according to the time range
   * 0 If it doesn't match any iteration
   * 1 If it matches the current iteration
   * 2 If it is a retrospect iteration
   */
  switch (timeRangeIteration) {
    case SELECTED_TIME_RANGE_CODE.RETROSPECT:
      tableColumns = columns.map(col => {
        const { name } = col;

        if (name === 'WIP') {
          return {
            dataPoint: metricNames.ACTIVE_BRANCHES,
            name: 'CARRYOVER',
            isSortedCol: true
          };
        }

        return col;
      });
      break;
    default:
      break;
  }
  const withMemberOfLabel = !isTeamLicense;
  const metricsWithSelected = metrics.items.map(metricItem => {
    const selectedTimeContributorTeams = _.get(
      selectedTimeContributorsMap,
      metricItem.contributor_id,
      []
    );
    const currentContributorTeams = _.get(
      currentContributorsMap,
      metricItem.contributor_id,
      []
    );
    const searchTeams = isVPMode
      ? _.get(search, 'teams', '').split(',')
      : [_.get(selectedTeam, 'id', '').toString()];
    return {
      ...metricItem,
      team: getTeamInfo(
        selectedTimeContributorTeams,
        searchTeams,
        currentContributorTeams,
        withMemberOfLabel
      )
    };
  });
  const tableData = getContributorsTableData({
    data: metricsWithSelected,
    contributors,
    time: {
      from: startDate,
      to: moment
        .min(moment(endDate || undefined), moment())
        .format(SEARCH_DATE_FORMAT)
    },
    timeRangeIteration,
    gitIntegrations,
    toggleModal,
    getContributors,
    toggleSnackBar,
    selectedTeamId,
    metricsCalculationStrategy: 'avg',
    benchmarkOrgSize
  });
  const currentIterationId = _.get(currentIteration, 'id', null);
  useEffect(() => {
    const search = QueryString.parse(location.search, {
      ignoreQueryPrefix: true
    });
    const defaultFilters = {};
    if (currentIteration) {
      const currentIterationTime = `${currentIteration.start_date},${currentIteration.end_date}`;
      if (!search.time) {
        defaultFilters.time = currentIterationTime;
      }
    }
    if (!search.order_by) {
      defaultFilters.order_by = `${metricNames.ACTIVE_BRANCHES},desc`;
    }

    if (!search.teams && selectedTeamId) {
      defaultFilters.teams = selectedTeamId;
    }

    if (Object.keys(defaultFilters).length) {
      history.replace({
        pathname: location.pathname,
        search: `?${QueryString.stringify(
          Object.assign({}, search, defaultFilters)
        )}`
      });
    }
  }, [currentIterationId]);

  const EditTeamButton = () => (
    <Flex justify='flex-end' padding='small' pr='medium'>
      <LBButton
        variant='outline'
        onClick={() => {
          if (isGroup) {
            onConfigureGroup({ ...selectedTeamForEditTeamsModal });
          } else {
            onConfigureTeam({ team: selectedTeamForEditTeamsModal });
          }
        }}
      >
        <Icon name='Pencil' size='smaller' /> Edit {isGroup ? 'Group' : 'Team'}
      </LBButton>
    </Flex>
  );

  // TODO: Almog - individual
  return (
    <GridChipFilterContainer
      preTableSlot={withPermissions({
        WrappedComponent: isVPMode || isAllTeams ? null : <EditTeamButton />,
        requiredPermissions: CAN_EDIT_ACCOUNT_TYPES
      })}
      disablePointInHistory
      getData={memoizedGetContributors}
      gitScopeToggle={gitScopeToggle}
      pageTag={TRACKING.PAGES.PEOPLE}
      pageTabTag={TRACKING.PAGE_TABS.INDIVIDUAL}
      data={metrics}
      tableData={() => tableData}
      filterChipLabelMap={filterChipLabelMap}
      columns={tableColumns}
      skeletonColumns={TABLE_SKELETONS}
      getReqFilterBody={getReqFilterBody}
      filtersConfig={filtersConfig}
      filtersGroupMap={filtersGroupMap}
      refreshOnDependencies={[returnNoData, contributors, selectedTeam]}
      lineHighlightOnHover
      postFiltersSlot={
        <Flex direction='row' justify='space-between' pl='tiny' pt='x-small'>
          <FormControlLabel
            label={
              <Text size='large' weight='300'>
                Show inactive members
              </Text>
            }
            control={
              <Checkbox
                onChange={event => setReturnNoData(event.target.checked)}
                checked={returnNoData}
                inputProps={{
                  'aria-label': 'primary checkbox'
                }}
                color='primary'
              />
            }
          />
        </Flex>
      }
    />
  );
};

export default Individuals;
